<template>
  <v-container grid-list-md fluid>
    <!--Index-->
    <v-layout v-if="view === 1" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="display-1">
          {{
            this.translate("system.title.consult") +
            this.translate("table." + this.entity + ".title")[1]
          }}
        </span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.acesso ? props.item.acesso.id_texto : "" }}</td>
            <td align="center" v-if="props.item.acesso_interno === 'user'">Usuário Comun</td>
            <td align="center" v-else-if="props.item.acesso_interno === 'dev'">Desenvolvedor</td>
            <td align="center" v-else-if="props.item.acesso_interno === 'admin'">Administrador</td>
            <td align="center">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasAccess('usuario', 'update')"
                v-if="props.item.acesso_interno !== 'dev' || $auth.user().acesso_interno === 'dev'"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item, props.item.id, true)"
                :disabled="!hasAccess('usuario', 'delete')"
                v-if="props.item.acesso_interno !== 'dev' && props.item.id != $auth.user().id"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <v-layout v-else wrap justify-center align-center>
      <v-flex xs12>
        <span class="display-1">{{ formTitle }}</span>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field
          name="name"
          required
          :label="translate('table.' + entity + '.field.name')"
          v-model="editedItem.name"
          :error-messages="errors.collect('name')"
          v-validate="'required'"
          :data-vv-as="translate('table.' + entity + '.field.name')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field
          name="email"
          required
          :label="translate('table.' + entity + '.field.email')"
          v-model="editedItem.email"
          :error-messages="errors.collect('email')"
          v-validate="'required'"
          :data-vv-as="translate('table.' + entity + '.field.email')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-autocomplete
          name="acesso_id"
          :label="translate('table.' + entity + '.field.acesso_id')"
          required
          v-model="editedItem.acesso_id"
          :items="acessos"
          :error-messages="errors.collect('acesso_id')"
          item-text="id_texto"
          item-value="id"
          v-validate="'required'"
          :data-vv-as="translate('table.' + entity + '.field.acesso_id')"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md3>
        <v-autocomplete
          :disabled="this.$auth.user().id === editedItem.id"
          name="acesso_interno"
          :label="translate('table.' + entity + '.field.acesso_interno')"
          v-model="editedItem.acesso_interno"
          :items="acessos_internos"
          item-text="id_texto"
          item-value="id"
        ></v-autocomplete>
      </v-flex>
    </v-layout>

    <v-btn
      v-if="view === 1"
      color="primary"
      dark
      fab
      fixed
      bottom
      right
      @click="create"
      :disabled="!hasAccess('usuario', 'create')"
    >
      <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
    </v-btn>

    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-btn v-model="fab" slot="activator" fab color="primary" dark :disabled="saving" :loading="saving" @click="save()">
          <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
          <v-icon>{{ this.translate("system.button.save.icon") }}</v-icon>
        </v-btn>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="secondary" :disabled="saving" :loading="saving" @click="saveNew()">
            <v-icon>{{ this.translate("system.button.save_new.icon") }}</v-icon>
          </v-btn>
          <span>{{ this.translate("system.button.save_new.title") }}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-btn v-if="view === 3" color="primary" dark fab :disabled="saving" :loading="saving" @click="save()">
        <v-icon>{{ this.translate("system.button.done.icon") }}</v-icon>
      </v-btn>

      <v-btn fab small @click="close">
        <v-icon>{{ this.translate("system.button.close.icon") }}</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}
</style>

<script>
import crud from "./../../mixin/crud";
import acl from "./../../mixin/acl";

export default {
  mixins: [crud, acl],
  components: {},
  data: () => ({
    entity: "users",
    tab: null,
    fab: null,
    acessos: [],
    acessos_internos: [],
    usuario_acesso: [],
  }),
  created() {
    this.initialize();
    this.editedItem = { ativo: true };
    this.defaultItem = { ativo: true };
    this.usuario_acesso = this.translate("value.usuario_acesso");
    if (this.$auth.user().acesso_interno !== "dev") {
      this.usuario_acesso.pop();
    }
  },
  computed: {
    headers: function () {
      return [
        { text: this.translate("table." + this.entity + ".field.name"), value: "name" },
        { text: this.translate("table." + this.entity + ".field.email"), value: "email" },
        { text: this.translate("table." + this.entity + ".field.acesso_id"), value: "acesso_id" },
        {
          text: this.translate("table." + this.entity + ".field.acesso_interno"),
          value: "acesso_id",
          align: "center",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  methods: {
    afterInitialize() {
      this.acessos = this.resBody.acessos;
      this.acessos_internos = [
        { id: "admin", id_texto: "Administrador" },
        { id: "user", id_texto: "Usuário Comun" },
      ];
      if (this.$auth.user().acesso_interno === "dev") {
        this.acessos_internos.push({ id: "dev", id_texto: "Desenvolvedor" });
      }
      console.log(this.acessos_internos);
    },
    afterSave() {
      if (this.$auth.user().acesso && this.$auth.user().id === this.editedItem.id) {
        window.location.reload(false);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/Usuario.vue